// key661 ~ 701
const auth = {
  ko: {
    key661: '해당 유저(사용자)는 접근이 불가합니다.',
    key662: 'NEXA 관제 시스템에 오신걸 환영합니다.',
    key663: '로그인정보가 일치하지 않습니다.',
    key664: '아이디',
    key665: '비밀번호',
    key666: '아이디 기억하기',
    key667: '아이디가 기억나지 않으세요?',
    key668: '아이디 찾기',
    key669: '비밀번호 찾기',
    key670: '회원가입하기',
    // 회원가입
    key671: '회원가입',
    key672: '사공사 정보',
    key673: '사공사명',
    key674: '사업주명',
    key675: '사공사 연락처',
    key676: '사업자 등록번호',
    key677: '사업자확인',
    key678: '사업자등록증',
    key679: '업로드',
    key680: '기본 정보',
    key681: '아이디',
    key682: '아이디',
    key683: '중복확인',
    key684: '비밀번호',
    key685: '비밀번호',
    key686: '비밀번호 확인',
    key687: '비밀번호 확인',
    key688: '이메일 주소',
    key689: '담당자 이메일',
    key690: '회원가입',
    key691: '이미 존재하는 아이디입니다.',
    key692: '사용가능한 아이디입니다.',
    key693: '등록 가능한 사업자입니다.',
    key694: '이미 등록되어있는 사업자입니다.',
    key695: '아이디 중복확인을 확인하세요.',
    key696: '비밀번호가 일치하지 않습니다.',
    key697: '등록가능한 사업자가 아닙니다.',
    key698: '해당 이메일주소는 이미 가입되어 있습니다.',
    key699: '신청이 완료되었습니다.',
    key700: '확인',
    key701: '확인',
    // 비밀번호 변경
    key702: '임시로 발급된 비밀번호 입니다. 변경 후 다시 로그인하여 주시기 바랍니다.',
    key703: '아이디 / 비밀번호 찾기',
    key704: '아이디 / 비밀번호 찾기',
    key705: '사공사 명과 회원가입시 사용했던 이메일 주소를 적어주세요.',
    key706: '이메일로 아이디와 변경된 비밀번호를 전달 드립니다.',
    key707: '이메일 주소',
    key708: '이메일 발송하기',
    key709: '아이디와 임시비밀번호를 발송하였습니다.',
    key710: '회원가입시 사용했던 이메일 주소와 매칭이 도착하지 않았거나 해당 사업자로 등록된 유저가지가 없습니다.',
    key711: '고객센터 전화번호 064 - 745 - 0420',
    key712: '아직 회원이 아니십니까?',
    key713: '회원가입하기',
  },
  en: {
    key661: 'The user does not have access.',
    key662: 'Welcome to the Automon Control System.',
    key663: 'The login information does not match.',
    key664: 'ID',
    key665: 'Password',
    key666: 'Remember ID',
    key667: 'Forgot your ID?',
    key668: 'Find ID',
    key669: 'Find Password',
    key670: 'Sign Up',
    key671: 'Sign Up',
    key672: 'Installer Information',
    key673: 'Installer Name',
    key674: 'Business Owner Name',
    key675: 'Installer Contact Number',
    key676: 'Business Registration Number',
    key677: 'Verify Business',
    key678: 'Business Registration Certificate',
    key679: 'Upload',
    key680: 'Basic Information',
    key681: 'Username',
    key682: 'Username',
    key683: 'Check for Duplicates',
    key684: 'Password',
    key685: 'Password',
    key686: 'Confirm Password',
    key687: 'Confirm Password',
    key688: 'Email Address',
    key689: 'Manager\'s Email',
    key690: 'Sign Up',
    key691: 'This username already exists.',
    key692: 'This username is available.',
    key693: 'This business can be registered.',
    key694: 'This business is already registered.',
    key695: 'Please check for duplicate username.',
    key696: 'Passwords do not match.',
    key697: 'This business cannot be registered.',
    key698: 'This email address has already been registered.',
    key699: 'Your application has been successfully submitted.',
    key700: 'Confirm',
    key701: 'Confirm',
    key702: 'This is a temporary password. Please change it before using the system again.',
    key703: 'Find ID / Password',
    key704: 'Find ID / Password',
    key705: 'Please enter the installer name and the email address used during registration.',
    key706: 'Your ID and the new password will be sent to your email.',
    key707: 'Email Address',
    key708: 'Send Email',
    key709: 'Your ID and temporary password have been sent.',
    key710: 'If you do not receive an email at the address used during registration, please contact our customer service center.',
    key711: 'Customer Service Phone Number: 064 - 745 - 0420',
    key712: 'Not a member yet?',
    key713: 'Sign Up',
  },
  vi: {
    key661: 'Người dùng này không có quyền này cập.',
    key662: 'Chào mừng bạn đến với Hệ thống giám sát Automon.',
    key663: 'Thông tin đăng nhập không khớp. / Mật khẩu không đúng.',
    key664: 'Tài khoản',
    key665: 'Mật khẩu',
    key666: 'Ghi nhớ tài khoản',
    key667: 'Bạn quên tài khoản?',
    key668: 'Tìm tài khoản',
    key669: 'Tìm mật khẩu',
    key670: 'Đăng ký thành viên',
    key671: 'Đăng ký thành viên',
    key672: 'Thông tin đơn vị thi công',
    key673: 'Tên đơn vị thi công',
    key674: 'Tên chủ doanh nghiệp',
    key675: 'Số điện thoại liên hệ',
    key676: 'Mã số đăng ký kinh doanh',
    key677: 'Xác nhận doanh nghiệp',
    key678: 'Giấy chứng nhận đăng ký kinh doanh',
    key679: 'Tải lên',
    key680: 'Thông tin cơ bản',
    key681: 'Tài khoản',
    key682: 'Tài khoản',
    key683: 'Kiểm tra trùng lặp',
    key684: 'Mật khẩu',
    key685: 'Mật khẩu',
    key686: 'Xác nhận mật khẩu',
    key687: 'Xác nhận mật khẩu',
    key688: 'Địa chỉ email',
    key689: 'Email của người phụ trách',
    key690: 'Đăng ký thành viên',
    key691: 'Tên tài khoản này đã tồn tại.',
    key692: 'Tên tài khoản này có thể sử dụng.',
    key693: 'Doanh nghiệp có thể đăng ký.',
    key694: 'Doanh nghiệp này đã được đăng ký.',
    key695: 'Vui lòng kiểm tra trùng lặp tài khoản.',
    key696: 'Mật khẩu không trùng khớp. / Mật khẩu không đúng.',
    key697: 'Doanh nghiệp này không thể đăng ký.',
    key698: 'Địa chỉ email này đã được sử dụng.',
    key699: 'Yêu cầu đăng ký đã hoàn tất.',
    key700: 'Xác nhận',
    key701: 'Xác nhận',
    key702: 'Đây là mật khẩu tạm thời. Vui lòng đổi mật khẩu trước khi đăng nhập lại hệ thống.',
    key703: 'Tìm tài khoản / Mật khẩu',
    key704: 'Tìm tài khoản / Mật khẩu',
    key705: 'Vui lòng nhập tên đơn vị thi công và địa chỉ email đã sử dụng khi đăng ký.',
    key706: 'Tài khoản và mật khẩu mới sẽ được gửi đến email của bạn.',
    key707: 'Địa chỉ email',
    key708: 'Gửi email',
    key709: 'Tài khoản và mật khẩu tạm thời đã được gửi đi.',
    key710: 'Nếu bạn không nhận được email qua địa chỉ email đã sử dụng khi đăng ký, vui lòng liên hệ với trung tâm dịch vụ khách hàng.',
    key711: 'Số điện thoại trung tâm hỗ trợ khách hàng: 064 - 745 - 0420',
    key712: 'Bạn chưa phải là thành viên?',
    key713: 'Đăng ký thành viên',
  }
}
export default auth;